import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ChangeDetectorRef,
} from "@angular/core";
import _ from "lodash";
import { NzModalService } from "ng-zorro-antd/modal";

import { TaskDetailService } from "@root/router/component/task/task-detail/task-detail.service";
import { ModalService } from "@root/router/index/modal.service";
import { TranslateService } from "@root/shared/service/translate.service";
import { BeFalseAfter } from "@root/util/decorator";
import { StoreService } from "@root/shared/service/store.service";
import { NzDrawerRef } from "ng-zorro-antd/drawer";
import { NavigationStart, Router } from "@angular/router";
import { filter } from "rxjs";
import { NzMessageService } from "ng-zorro-antd/message";

@Component({
  selector: "host-task-detail",
  templateUrl: "./task-detail.component.html",
  styleUrls: ["./task-detail.component.scss"],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskDetailComponent implements OnInit, OnChanges {
  @Input() taskId;
  @Input() date = null;
  @Input() houseId = null;
  @Input() staffId = null;
  @Output() onModify = new EventEmitter();
  // @Output() closeSidebar = new EventEmitter();
  // @Output() needRefresh = new EventEmitter();

  detail = null;
  status = null;
  logList = [];
  listOfTask = [];
  @BeFalseAfter(1000) loading = false;

  get isDeleteable() {
    if (!this.detail) {
      return false;
    }
    const opid = +this.storeService.get("operator_id");
    return (
      this.detail.operator_id === opid ||
      this.detail.create_operator_id === opid ||
      this.detail.operator_id === this.detail.create_operator_id
    );
  }

  constructor(
    private taskSrv: TaskDetailService,
    private localModalService: ModalService,
    private modalService: NzModalService,
    private msg: NzMessageService,
    private t: TranslateService,
    private storeService: StoreService,
    private cd: ChangeDetectorRef,
    private drawerRef: NzDrawerRef,
    private router: Router,
  ) {}

  ngOnInit() {
    this.initTaskList();

    this.initCurrentTaskDetail();
    this.initLogList();

    this.router.events.pipe(filter((e) => e instanceof NavigationStart)).subscribe(() => this.drawerRef.close());
  }

  ngOnChanges(changes: SimpleChanges) {}

  triggerNgOnChanges() {
    this.initTaskList();

    this.initCurrentTaskDetail();
    this.initLogList();
  }

  /**
   * 当点击的日历格子有多个任务时，右侧的任务详情应当显示 任务日程表，日程表的数据为：当前成员在当日的所有任务。
   * 其他情况都展示该房间当天所有任务
   */
  private initTaskList() {
    this.listOfTask = [];
    const params = {
      expected_begin: this.date,
      expected_end: this.date,
      page: 1,
      page_size: 1000,
    };
    if (this.houseId) {
      Object.assign(params, {
        house_ids: this.houseId ? JSON.stringify([this.houseId]) : null,
      });
    } else {
      Object.assign(params, {
        schedule_staff_id: this.staffId,
      });
    }

    this.taskSrv.getTaskList(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.listOfTask = _.get(res, "data.list");

        /**
         * @todo
         * @compact
         */
        this.cd.detectChanges();
      }
    });
  }

  onClickTask(id) {
    this.taskId = id;
    this.initCurrentTaskDetail();
    this.initLogList();
  }

  private initCurrentTaskDetail() {
    this.taskSrv
      .getTaskDetail({
        id: this.taskId,
      })
      .subscribe((res) => {
        if (res.error_code === 0) {
          const detail = res?.data?.schedule_task;
          detail.check_list = detail.check_list?.map((item) => ({
            ...item,
            status: !!item.status,
          }));
          this.detail = detail;
          this.status = this.detail.status;
          this.cd.detectChanges();
        }
      });
  }

  private initLogList() {
    this.taskSrv
      .getLogList({
        page: 1,
        page_size: 1000,
        search_words: this.taskId,
        search_type: "schedule_task",
      })
      .subscribe((res) => {
        if (res.error_code === 0) {
          this.logList = _.get(res, "data.list");
          this.cd.detectChanges();
        }
      });
  }

  onSelectStatus(status) {
    const params = {
      id: this.taskId,
      expected_date: this.detail.expected_date,
      expected_time: this.detail.expected_time,
      level: this.detail.level,
      currency_type: this.detail.currency_type,
      fee: this.detail.fee,
      status: status,
    };
    this.taskSrv.updateTask(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.msg.success(this.translate("company.dashboard.update_hc.toast.success"));
        // 更新成功之后的操作
        // this.needRefresh.emit("OK");
        this.onModify.emit();
        this.initTaskList();
        _.delay(() => {
          this.initLogList();
        }, 1000);
      }
    });
  }

  onDeleteTask() {
    this.modalService.warning({
      // nzTitle: '确认删除任务？',
      nzTitle: this.translate("task.detail.sidebar.delete.modal.title"),
      nzOkText: this.translate("word.confirm"),
      nzCancelText: this.translate("word.cancel"),
      nzOnOk: () => this.requestDeleteTask(),
    });
  }

  private requestDeleteTask() {
    this.taskSrv.deleteTask({ id: this.taskId }).subscribe((res) => {
      if (res.error_code === 0) {
        this.close();
        // this.needRefresh.emit("OK");
        // this.closeSidebar.emit("OK");
      }
    });
  }

  //#region Check list

  private requestUpdateCheckListStatus(id, status) {
    const params = {
      task_id: this.taskId,
      check_list_id: id,
      status: status ? 1 : 0,
    };

    this.taskSrv.requestUpdateCheckListStatus(params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.onModify.emit();
      }
    });
  }

  onCheckListChange(id, status) {
    console.log("model change: ", id, status);
    this.requestUpdateCheckListStatus(id, status);
  }

  //#endregion

  createTask() {
    const modal = this.localModalService.displayCreateTaskModal({
      expected_date: _.get(this.detail, "expected_date"),
      house: { id: _.get(this.detail, "house.id") },
    });
    modal.afterClose.subscribe((res) => {
      if (res === "OK") {
        this.onModify.emit();
        // this.needRefresh.emit("OK");
      }
    });
  }

  close() {
    this.taskSrv.closeDrawer$.next();
    this.drawerRef.close();
    // this.closeSidebar.emit("OK");
  }

  modify() {
    const params = {
      ...this.detail,
    };
    const modal = this.localModalService.displayCreateTaskModal(params);
    modal.afterClose.subscribe((res) => {
      if (res === "OK") {
        this.initCurrentTaskDetail();
        this.initTaskList();
        this.onModify.emit();
        _.delay(() => {
          this.initLogList();
        }, 1000);
        // this.needRefresh.emit("OK");
      }
    });
  }

  // showBigPhotos(url) {
  //   this.localModalService.displayImageMagnifier(url);
  // }

  getType(type) {
    return this.t.syncGet(`task.word.type.type_${type}`);
  }

  getLevel(level) {
    return this.t.syncGet(`task.word.level.level_${level}`);
    // return level === 0 ? '标准' : level === 1 ? '简单' : '高级';
  }

  private translate(key, params?) {
    return this.t.syncGet(key, params);
  }
}
